import OperationTableRow from "./OperationTableRow";

const OperationTableBody = ({operations}) => {
    
    return (
        <tbody>
            {operations?.map(operation=>{
                return (
                    <OperationTableRow
                        key={operation.ID}
                        operation={operation}/> )
            })}
        </tbody>)
}

export default OperationTableBody;